<template>
       <div class="row login-page flex justify-center flex-col sm:flex-row">
              
       <Form />
              
       </div>
</template>

<script>
import Form from '@/components/Forms/Form.vue'

export default {
        components: {
              'Form': Form
       }
}

</script>

<style>
</style>